/* Back-in-stock modal for Jeune Âme
 * - Prefills contact[body] with product / variant / URL
 * - Posts to /contact (Shopify) and also beacons to CF Worker
 * - A11y: focus trap, ESC close, click backdrop, restore focus
 */

(() => {
  // ---------- Config (можно вынести в settings) ----------
  const WORKER_INGEST_URL  = 'https://shopify-jeuneame.2404kovalev.workers.dev/ingest/notify_subscribe';
  const PUBLIC_FORM_SECRET = '9b1f2a7e5d934b2c8f40a1d7e3c6f9a0f4d2b7c1e9a38d57c0af1b2c3d4e5f6a';

  // ---------- Shortcuts ----------
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ---------- Modal helpers ----------
  const trapFocus = {
    _focusables: [],
    _first: null,
    _last: null,
    enable(root) {
      this._focusables = $$(
        'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])',
        root
      ).filter(el => el.offsetParent !== null);
      this._first = this._focusables[0];
      this._last  = this._focusables[this._focusables.length - 1];
      root.addEventListener('keydown', this._onKeydown);
    },
    disable(root) {
      root.removeEventListener('keydown', this._onKeydown);
      this._focusables = [];
      this._first = this._last = null;
    },
    _onKeydown(e) {
      if (e.key !== 'Tab') return;
      const items = trapFocus._focusables;
      if (!items.length) return;
      if (e.shiftKey && document.activeElement === trapFocus._first) {
        e.preventDefault(); trapFocus._last.focus();
      } else if (!e.shiftKey && document.activeElement === trapFocus._last) {
        e.preventDefault(); trapFocus._first.focus();
      }
    }
  };

  let lastActiveEl = null;

  function openModal() {
    const modal = $('#NotifyModal');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    lastActiveEl = document.activeElement;
    trapFocus.enable(modal);
    // фокус на email
    setTimeout(() => $('#NotifyEmail')?.focus(), 0);
  }

  function closeModal() {
    const modal = $('#NotifyModal');
    if (!modal) return;
    trapFocus.disable(modal);
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    lastActiveEl?.focus?.();
  }

  // ---------- Ensure contact[body] exists ----------
  function ensureBodyField(form) {
    let body = form.querySelector('#NotifyBody');
    if (!body) {
      body = document.createElement('textarea');
      body.id = 'NotifyBody';
      body.name = 'contact[body]';
      body.hidden = true;
      form.appendChild(body);
    }
    return body;
  }

  // ---------- Prefill body ----------
  function fillBodyFromButton(btn, form) {
    const body = ensureBodyField(form);
    const pTitle = btn.getAttribute('data-product-title') || document.title || '';
    const vTitle = btn.getAttribute('data-variant-title') || '';
    const vId    = btn.getAttribute('data-variant-id') || '';
    const url    = location.href;

    body.value =
      'Back-in-stock request\n' +
      `Product: ${pTitle}\n` +
      (vTitle ? `Variant: ${vTitle}\n` : '') +
      (vId    ? `Variant ID: ${vId}\n` : '') +
      `URL: ${url}\n`;
  }

  // ---------- Variant change hooks ----------
  function updateVariantDataOnBtn(variant) {
    const btn = $('#NotifyButton');
    if (!btn || !variant) return;
    if (variant.id)    btn.setAttribute('data-variant-id', variant.id);
    if (variant.title) btn.setAttribute('data-variant-title', variant.title);
  }
  document.addEventListener('variant:change',  e => updateVariantDataOnBtn(e?.detail?.variant));
  document.addEventListener('variant:changed', e => updateVariantDataOnBtn(e?.detail?.variant));

  // ---------- Open / Close ----------
  document.addEventListener('click', (e) => {
    const target = e.target;

    // open
    if (target && target.id === 'NotifyButton') {
      const form = $('#NotifyForm');
      if (form) fillBodyFromButton(target, form);
      openModal();
    }

    // close by X
    if (target && target.id === 'NotifyClose') closeModal();

    // close by backdrop
    if (target && target.closest?.('.notify-modal__backdrop')) closeModal();

    // close by [data-close]
    if (target && target.dataset?.close) closeModal();
  });

  // close by ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !$('#NotifyModal')?.hidden) closeModal();
  });

  // ---------- Submit handlers ----------
  document.addEventListener('DOMContentLoaded', () => {
    const form = $('#NotifyForm');
    if (!form) return;

    const submitBtn = form.querySelector('[type="submit"]');
    const ACTION_URL = form.action || '/contact';
    ensureBodyField(form);

    // Side-channel telemetry (non-blocking)
    form.addEventListener('submit', () => {
      try {
        const payload = {
          type:   'back_in_stock_subscribe',
          secret: PUBLIC_FORM_SECRET,
          email:  $('#NotifyEmail', form)?.value || '',
          body:   $('#NotifyBody', form)?.value || '',
          consent: !!form.querySelector('.notify-consent__cb')?.checked,
          page_url: location.href,
          shop: (window.Shopify && Shopify.shop) || '',
          ts: new Date().toISOString(),
          ua: navigator.userAgent
        };
        const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        navigator.sendBeacon(WORKER_INGEST_URL, blob);
      } catch (err) {
        console.warn('Notify → Worker beacon failed:', err);
      }
    });

    // Primary submit to /contact
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      // UX states
      const originalText = submitBtn?.textContent;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
        const loading = submitBtn.getAttribute('data-loading-text') || 'Sending…';
        submitBtn.textContent = loading;
      }

      const statusEl = $('#NotifyStatus');

      try {
        const body = new URLSearchParams(new FormData(form));
        await fetch(ACTION_URL, {
          method: 'POST',
          headers: { 'Accept': 'text/html' },
          body
        });

        if (statusEl) {
          statusEl.textContent = 'Thanks! We will email you when it’s back in stock.';
          statusEl.hidden = false;
          statusEl.classList.remove('visually-hidden');
          statusEl.setAttribute('role', 'status');
          statusEl.setAttribute('aria-live', 'polite');
        }

        form.reset();
        ensureBodyField(form);
        // закрываем модалку после статуса (можно оставить открытой — на твой выбор)
        setTimeout(closeModal, 800);
      } catch (err) {
        console.warn('Notify → fetch failed, fallback submit()', err);
        form.submit(); // full-page fallback
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          submitBtn.textContent = originalText || 'Subscribe';
        }
      }
    }, { capture: true });
  });
})();
